import {IComponentOptions} from "angular";
import "./previous-applications.less";
import {Application} from "../../../shared/model/Application";

class PreviousApplicationsController {
    public previousApplications: Application[];
    public currentApplication: Application;

    private getApplicationHistory() {
        return this.previousApplications ?
            this.previousApplications.filter((appl) => appl.id !== this.currentApplication.id) :
            [];
    }

    private getApplicationCourses(application: Application) {
        return application.coursesApplied.map((course) => course.courseCode).join(", ");
    }

}

export const PreviousApplicationsComponent: IComponentOptions = {
    bindings: {
        previousApplications: "<",
        currentApplication: "<"
    },
    controller: PreviousApplicationsController,
    template: require("./previous-applications.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/application/previous-applications/previous-applications.component.ts